module.exports = "/assets/data/9f63887dd15b01b63b794d1376e980ef-LA2.data.json";